export default __webpack_public_path__ + "static/media/TablePlaceholder.c8ed82da.png";